<template>
  <el-dialog
    class="delete-spv-node common-dialog"
    title="删除SPV节点"
    :visible.sync="showDialog"
    top="35vh"
  >
    <div class="hint">是否删除ID为【 {{ handleInfo?.id }} 】的SPV节点？</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'DeleteSpvNode',
  props: {
    dialogVisible: Boolean,
    handleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$apis.spvlightnodes
        .deleteSpvNode({
          spvId: self.handleInfo.id
        })
        .then(res => {
          if (res && res.data && self.$utils.isNumber(res.data.SpvId)) {
            self.showDialog = false

            self.$emit('deleteSuccess')
            self.$message({
              type: 'success',
              message: '删除SPV节点成功!'
            })
          } else {
            self.$message({
              type: 'error',
              message: '删除SPV节点失败!'
            })
          }
          console.log(res)
        })
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('delete-spv-node', (), ());

.delete-spv-node {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }
}
</style>
